import { render, staticRenderFns } from "./UpdateIndex.vue?vue&type=template&id=04ed6249&scoped=true&"
import script from "./UpdateIndex.vue?vue&type=script&lang=js&"
export * from "./UpdateIndex.vue?vue&type=script&lang=js&"
import style0 from "./UpdateIndex.vue?vue&type=style&index=0&id=04ed6249&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed6249",
  null
  
)

export default component.exports